const language = {
    en: 'English',
    es: 'Español',
    de: 'Deutsch',
    it: 'Italiano',
    fr: 'Français',
    rb: '日语',
    tha: 'ภาษาไทย',
    phl: 'Pilipino'
}
const lang = {
    getKey: function(value) {
      return Object.keys(language).find(key => language[key] == value);
    },
    values:function(){
      const values = [];
      for (const key in language) {
        if (language.hasOwnProperty(key)) {
          values.push(language[key])
        }
      }
      return values;
    }
}
  
export default lang